import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';

function HeaderCard({ title, children }) {
  return (
    <Box>
      <Card>
        <CardContent>
          <Stack spacing={1}>
            <Typography variant="h5" color="primary">
              {title}
            </Typography>
            {children}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}

export default HeaderCard;
